import { AuthLayout } from '../../components/layout/AuthLayout'
import { RegisterForm } from '../../components/forms/RegisterForm'
import { DashboardPreview } from '../../components/layout/DashboardPreview'

export const RegisterPage = () => {
  return (
    <AuthLayout preview={<DashboardPreview />}>
      <RegisterForm />
    </AuthLayout>
  )
}
